import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import ReactPaginate from 'react-paginate';
import PropTypes from 'prop-types';
import JobList from '../Jobs/JobList';
import JobFilter from '../../Jobs/JobsTable/JobFilter';

class CustomerJobs extends Component {
    static propTypes = {
        url: PropTypes.string.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            offset: 0,
            status: 'completed',
            waste_journey: 0,
            searchTerm: '',
        };
    }

    loadJobsFromServer() {
        $.ajax({
            url: this.props.url,
            data: {
                limit: this.props.perPage,
                offset: this.state.offset,
                status: this.state.status,
                waste_journey: this.state.waste_journey,
            },
            dataType: 'json',
            type: 'GET',
            success: (data) => {
                this.setState({
                    data: data.jobs,
                    pageCount: Math.ceil(data.total / this.props.perPage),
                });
            },

            error: (xhr, status, err) => {
                console.log(this.props.url, status, err.toString());
            },
        });
    }

    componentDidMount() {
        this.loadJobsFromServer();
    }

    handlePageClick = (data) => {
        let selected = data.selected;
        let offset = Math.ceil(selected * this.props.perPage);

        this.setState({ offset: offset }, () => {
            this.loadJobsFromServer();
        });
    };

    handleSearchClick = () => {
        if (this.state.searchTerm !== '') {
            $.ajax({
                url: this.props.searchUrl,
                headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                data: {
                    search_term: this.state.searchTerm,
                    status: this.state.status,
                },
                dataType: 'json',
                type: 'POST',
                success: (data) => {
                    this.setState({
                        data: data.jobs,
                        pageCount: Math.ceil(data.total / this.props.perPage),
                        searchTerm: '',
                    });
                },
                error: (xhr, status, err) => {
                    console.log(this.props.searchUrl, status, err.toString());
                },
            });
        }
    };

    handleClick = (url) => {
        window.location.href = url;
    };

    handleSearchChange = (e) => {
        this.setState({ searchTerm: e.target.value });
    };

    handleChange = (e) => {
        let waste_journey = e.value === 'waste_journey' ? 1 : 0;
        let status = e.value === 'completed' || e.value === 'waste_journey' ? 'completed' : e.value;
        this.setState(
            {
                status: status,
                offset: 0,
                waste_journey: waste_journey,
            },
            () => {
                this.loadJobsFromServer();
            }
        );
    };

    render() {
        return (
            <Fragment>
                <div className="row mt-4">
                    <div className="col-12">
                        <div className="form-inline">
                            <div className="col-10 pl-0">
                                <input
                                    type="text"
                                    className="form-control w-100"
                                    placeholder="Search job..."
                                    value={this.state.searchTerm}
                                    onChange={(e) => this.handleSearchChange(e)}
                                />
                            </div>
                            <div className="col-2 pr-0">
                                <button className="btn btn-cw-primary w-100" onClick={() => this.handleSearchClick()}>
                                    Search
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row pt-4">
                    <div className="col-12">
                        <div className="cw-bg-grey py-1 d-flex justify-content-between align-items-center">
                            <div>
                                <h6 className="py-2 pl-2 text-white">Jobs</h6>
                            </div>
                            <div className="pr-2 w-25 trans">
                                <JobFilter options={this.props.filterOptions} onChange={this.handleChange} />
                            </div>
                        </div>
                    </div>
                </div>

                <JobList
                    data={this.state.data}
                    onClick={this.handleClick}
                    baseUrl={this.props.baseUrl}
                    isAdmin={this.props.isAdmin}
                />
                <ReactPaginate
                    previousLabel={'previous'}
                    nextLabel={'next'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={this.state.pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={this.handlePageClick}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                />
            </Fragment>
        );
    }
}

if (document.getElementById('customer-jobs')) {
    let element = document.getElementById('customer-jobs');

    ReactDOM.render(
        <CustomerJobs
            url={element.dataset.url}
            searchUrl={element.dataset.searchurl}
            perPage={10}
            filterOptions={JSON.parse(element.dataset.filter)}
            baseUrl={element.dataset.base_url}
            isAdmin={element.dataset.is_admin}
        />,
        element
    );
}

export default CustomerJobs;
